export default __webpack_public_path__ + "static/media/chest-5.fad0f8d3.webp";